import client from './client';

// ── 统计 ──
export const getStats = () => client.get('/admin/stats/');

// ── 用户管理 ──
export const getUsers = (params) => client.get('/admin/users/', { params });
export const editUser = (id, data) => client.patch(`/admin/users/${id}/edit/`, data);
export const getUserEnterpriseOptions = () => client.get('/admin/users/enterprise-options/');
export const toggleUserActive = (id) => client.post(`/admin/users/${id}/toggle_active/`);
export const toggleEngineerMode = (id) => client.post(`/admin/users/${id}/toggle_engineer_mode/`);
export const deleteMember = (id) => client.post(`/admin/users/${id}/delete_member/`);
// Phase G (2026-04-29)：批量软删除成员（best-effort）
export const bulkDeleteMembers = (ids) =>
  client.post('/admin/users/bulk_delete_member/', { ids });
// Phase C (2026-04-23)：Admin 改用户工作方向
export const updateUserWorkDirection = (id, work_direction) =>
  client.post(`/admin/users/${id}/update_work_direction/`, { work_direction });
// 超管设置讲师角色 (instructor-role-upgrade): personal ↔ instructor
// 仅超管可调用,后端有完整边界校验
export const setUserRole = (id, role) =>
  client.post(`/admin/users/${id}/set_role/`, { role });

// ── 用户回收站 ──
export const getUserRecycleBin = () => client.get('/admin/users/recycle-bin/');
export const restoreUser = (id) => client.post(`/admin/users/recycle-bin/${id}/restore/`);
export const permanentDeleteUser = (id) => client.delete(`/admin/users/recycle-bin/${id}/destroy/`);
export const bulkPermanentDeleteUsers = (ids) =>
  client.post('/admin/users/recycle-bin/bulk_destroy/', { ids });

// ── 企业管理 ──
export const getEnterprises = (params) => client.get('/admin/enterprises/', { params });
export const getEnterprise = (id) => client.get(`/admin/enterprises/${id}/`);
export const createEnterprise = (data) => client.post('/admin/enterprises/', data);
export const updateEnterprise = (id, data) => client.patch(`/admin/enterprises/${id}/`, data);
export const deleteEnterprise = (id) => client.delete(`/admin/enterprises/${id}/`);
export const activateEnterprise = (id) => client.post(`/admin/enterprises/${id}/activate/`);
export const deactivateEnterprise = (id) => client.post(`/admin/enterprises/${id}/deactivate/`);

// ── 超管团队管理（class-stream A4，后端 model 名沿用 class/TrainingClass）──
// 后端: apps/enterprises/admin_class_views.py（IsAdminRole）。
// 风格与本文件其它块一致: 返回 axios response, 调用方取 .data。
export const getEnterpriseClasses = (entId, params) =>
  client.get(`/admin/enterprises/${entId}/classes/`, { params });
export const createEnterpriseClass = (entId, data) =>
  client.post(`/admin/enterprises/${entId}/classes/`, data);
export const renameEnterpriseClass = (entId, classId, data) =>
  client.patch(`/admin/enterprises/${entId}/classes/${classId}/`, data);
export const disableEnterpriseClass = (entId, classId) =>
  client.post(`/admin/enterprises/${entId}/classes/${classId}/disable/`);
export const transferEnterpriseClassMembers = (entId, classId, data) =>
  client.post(`/admin/enterprises/${entId}/classes/${classId}/transfer-members/`, data);
export const enableEnterpriseClasses = (entId, data) =>
  client.post(`/admin/enterprises/${entId}/enable-classes/`, data);
export const disableEnterpriseClasses = (entId) =>
  client.post(`/admin/enterprises/${entId}/disable-classes/`);

// ── 维度管理（V4 F.1：可配置维度）──
// V4 设计决策:
// - code 是稳定锚点 (创建时填, 之后不能改). 后端会拦 PATCH code 改动.
// - 删除不开放, 后端返回 405. 软停用走 PATCH is_active=false.
export const getDimensions = (params) => client.get('/admin/dimensions/', { params });
export const createDimension = (data) => client.post('/admin/dimensions/', data);
export const updateDimension = (id, data) => client.patch(`/admin/dimensions/${id}/`, data);
// V4 reorder: 批量改 sort_order. body = {order: [{id, sort_order}, ...]}.
export const reorderDimensions = (order) => client.post('/admin/dimensions/reorder/', { order });
// @deprecated V4 起后端返回 405. 保留导出避免破坏 import, 但调用必失败.
export const deleteDimension = (id) => client.delete(`/admin/dimensions/${id}/`);

// ── 维度介绍图管理（V4 F.2 / M24）──
// 后端: apps/dimensions/dim_intro_views.py (IsAdminRole 仅 admin/superadmin; current/ 公共可读)
// 上传必传 image_pc, 可选 image_mobile; 自动 bump version + 设 active + 关旧 active
export const getDimIntroImages = (params) =>
  client.get('/admin/dim-intro-images/', { params });
export const getDimIntroImageCurrent = () =>
  client.get('/admin/dim-intro-images/current/');
export const uploadDimIntroImage = (formData) =>
  client.post('/admin/dim-intro-images/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const activateDimIntroImage = (id) =>
  client.post(`/admin/dim-intro-images/${id}/activate/`);
export const deleteDimIntroImage = (id) =>
  client.delete(`/admin/dim-intro-images/${id}/`);
// 回滚到默认: 把所有 is_active 置 false → 首页 fallback 到默认 8 卡片网格
// 历史版本图本身不删, 之后还能 activateDimIntroImage(id) 把任意一版换回来
export const restoreDimIntroImageDefault = () =>
  client.post('/admin/dim-intro-images/restore_default/');

// ── 风险模板管理（V4 F.4 / M23）──
// 后端: apps/enterprises/admin_risk_template_views.py (IsAdminRole 仅 admin/superadmin)
// 风格与 admin.js 其它块一致: 返回 axios response, 调用方取 .data。
export const getRiskTemplates = (params) =>
  client.get('/admin/risk-templates/', { params });
export const createRiskTemplate = (data) =>
  client.post('/admin/risk-templates/', data);
export const updateRiskTemplate = (id, data) =>
  client.patch(`/admin/risk-templates/${id}/`, data);
export const deleteRiskTemplate = (id) =>
  client.delete(`/admin/risk-templates/${id}/`);

// ── 场景候选池管理（V5 报告 Page5 场景）──
// 后端: apps/reports/admin_scenario_pool_views.py (IsAdminRole, enterprise_admin 403)
export const getScenarioPool = (params) =>
  client.get('/admin/scenario-pool/', { params });
export const createScenarioPoolEntry = (data) =>
  client.post('/admin/scenario-pool/', data);
export const updateScenarioPoolEntry = (id, data) =>
  client.patch(`/admin/scenario-pool/${id}/`, data);
export const deleteScenarioPoolEntry = (id) =>
  client.delete(`/admin/scenario-pool/${id}/`);
export const getScenarioIcons = () =>
  client.get('/admin/scenario-pool/icons/');

// ── V4 M22: Prompt 后台（F.3）──
// 后端: apps/ai_engine/admin_prompt_views.py (IsAdminRole, enterprise_admin 403)
// 6 段 + 5 道安全网（版本控制 / 一键回滚 / 真 AI 预览 / auto fallback / 占位符 reference）
export const getPromptSegments = () => client.get('/admin/prompts/segments/');
export const getPromptSegmentDetail = (segment, params) =>
  client.get(`/admin/prompts/segments/${segment}/`, { params });
export const createPromptVersion = (segment, data) =>
  client.post(`/admin/prompts/segments/${segment}/versions/`, data);
export const activatePromptVersion = (segment, version) =>
  client.post(`/admin/prompts/segments/${segment}/activate/`, { version });
export const previewPromptSegment = (segment, prompt_text) =>
  client.post(`/admin/prompts/segments/${segment}/preview/`, { prompt_text });
export const getPromptPlaceholders = () =>
  client.get('/admin/prompts/placeholders/');
export const getPromptNotifications = () =>
  client.get('/admin/prompts/notifications/');
export const ackPromptNotification = (id) =>
  client.post(`/admin/prompts/notifications/${id}/ack/`);

// ── 题库管理 ──
export const getQuestions = (params) => client.get('/admin/questions/', { params });
export const getQuestion = (id) => client.get(`/admin/questions/${id}/`);
export const createQuestion = (data) => client.post('/admin/questions/', data);
export const updateQuestion = (id, data) => client.patch(`/admin/questions/${id}/`, data);
export const deleteQuestion = (id) => client.delete(`/admin/questions/${id}/`);
export const toggleQuestionActive = (id) => client.post(`/admin/questions/${id}/toggle_active/`);
export const bulkDeleteQuestions = (ids) => client.post('/admin/questions/bulk_delete/', { ids });

// ── 回收站 ──
export const getRecycleBin = () => client.get('/admin/questions/recycle-bin/');
export const restoreQuestion = (id) => client.post(`/admin/questions/recycle-bin/${id}/restore/`);
export const permanentDeleteQuestion = (id) => client.delete(`/admin/questions/recycle-bin/${id}/destroy/`);
export const bulkRestoreQuestions = (ids) => client.post('/admin/questions/recycle-bin/bulk_restore/', { ids });
export const importQuestionsExcel = (file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post('/admin/questions/import_excel/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const downloadQuestionTemplate = () =>
  client.get('/admin/questions/download_template/', { responseType: 'blob' });
// V5 M3：题库编辑表单下拉数据（场景标签白名单 + 三素质）
export const getQuestionMeta = () => client.get('/admin/questions/meta/');

// ── AI 策略配置 ──
export const getAIStrategies = () => client.get('/admin/ai-strategy/');
export const getAIStrategy = (id) => client.get(`/admin/ai-strategy/${id}/`);
export const createAIStrategy = (data) => client.post('/admin/ai-strategy/', data);
export const updateAIStrategy = (id, data) => client.put(`/admin/ai-strategy/${id}/`, data);
export const deleteAIStrategy = (id) => client.delete(`/admin/ai-strategy/${id}/`);
export const copyAIStrategy = (id) => client.post(`/admin/ai-strategy/${id}/copy/`);
export const setDefaultAIStrategy = (id) => client.post(`/admin/ai-strategy/${id}/set_default/`);
export const bindEnterpriseStrategy = (enterpriseId, strategyId) =>
  client.patch(`/admin/enterprises/${enterpriseId}/`, { strategy: strategyId || null });

// ── 用户测评历史 ──
export const getUserAssessments = (userId) =>
  client.get(`/admin/users/${userId}/assessments/`);

// ── 报告详情 ──
export const getAdminReportDetail = (assessmentId) =>
  client.get(`/admin/reports/${assessmentId}/detail/`);

// ── 管理员重新生成报告（兜底报告补救：用户端 done 态无重试入口）──
// 基础版：重跑整份 user_report（顶层粗略报告），会连带清掉并触发专业版重生。
export const regenerateAdminReport = (assessmentId) =>
  client.post(`/admin/reports/${assessmentId}/regenerate/`);

// 专业版：只重跑 detailed 块，保留 base；要求已解锁专业版。
export const regenerateAdminReportDetailed = (assessmentId) =>
  client.post(`/admin/reports/${assessmentId}/regenerate-detailed/`);

// ── 企业管理员：查看当前绑定策略 ──
export const getEnterpriseCurrentStrategy = () =>
  client.get('/admin/ai-strategy/enterprise-current/');
